<style>
    .scoped-interivew-email .user-tag{cursor: pointer;margin:5px;}
    .scoped-interivew-email .user-tag.disabled{text-decoration: line-through;background: #dddddd;color: #fff;border-color: transparent;}
</style>
<template>
    <el-dialog class="scoped-interivew-email" :title="senderTitle" :visible.sync="dialogFormVisible"
               v-if="params"
               :close-on-click-modal="false"
               :close-on-press-escape="false">
        <div class="editView" v-show="!isPreview" :key="renderKey">
            <div style="width:85%;margin: 0px auto 20px;">
                <p>已勾选{{params.length}}条数据</p>
                <el-table :data="dataList">
                    <el-table-column label="供应商" width="100" prop="supplierName"></el-table-column>
                    <el-table-column label="定薪数量" width="80" prop="supplierName">
                        <template slot-scope="scope">{{scope.row.rpIdList.length}}</template>
                    </el-table-column>
                    <el-table-column label="对接人(点击名字标签可不发送给该对接人)" prop="users">
                        <template slot-scope="scope">
                            <el-tag v-for="(item, index) in scope.row.contactList" :key="index" class="user-tag" :class="{'disabled': item.disabled === true}"
                                    @click.native="togglerUserActive(item)">{{item.name}}({{item.email}})</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="100" prop="number">
                        <template slot-scope="scope">
                            <a href="javascript:;" @click="previewEmail(scope.row)">预览</a>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <el-form :model="form" class="form-beauty">
                <el-form-item label="选择模板" :label-width="formLabelWidth">
                    <el-select placeholder="请选择模板" v-model="emailTemplate" clearable @change="renderEmailTemplate">
                        <el-option v-for="(item, key) in emailTemplateList" :key="key"
                                :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="邮件标题" :label-width="formLabelWidth">
                    <el-input v-model.trim="form.name" auto-complete="off" :maxlength="200" placeholder="请输入邮件标题"></el-input>
                </el-form-item>
                <el-form-item label="收件人" :label-width="formLabelWidth">
                    <user-group  ref="recipients" v-model="recipients" :allowEmail="true"></user-group>
                    <a href="javascript:;" @click="previewEmailByRecipients()" style="position: absolute;right: -40px;top: 0px;">预览</a>
                </el-form-item>
                <el-form-item label="抄送人" :label-width="formLabelWidth">
                    <user-group ref="ccList"  :allowEmail="true"></user-group>
                </el-form-item>
                <el-form-item label="附件" :label-width="formLabelWidth">
                    <file-upload
                            class="upload-desc"
                            :action="`${$axios.defaults.baseURL}/payment/template/fileInsert.api`"
                            v-model="fileList">
                        <el-button size="small" type="primary">点击上传</el-button>
                    </file-upload>
                </el-form-item>
                <el-form-item label="邮件内容" :label-width="formLabelWidth">
                    <div class="quickTool" v-if="placeHolders.length">
                        <el-tag v-for="(item, key) in placeHolders"
                                @click.native="$refs.editor.addAfterCursor(item.value)"
                                icon="el-icon-plus"
                                :key="key"
                                size="small">{{item.text}}</el-tag>
                    </div>
                    <vueditor v-model="form.contentCode" ref="editor"></vueditor>
                </el-form-item>
            </el-form>
        </div>
        <div class="previewView" v-if="isPreview">
            <div style="border-bottom: 1px solid #ddd;">
                <p style="font-size: 16px;font-weight: bold;">邮件标题：{{form.name}}</p>
                <p>收件人：<span v-for="(item, index) in interviewerUsers" v-if="item.disabled !== true"
                             :key="item.id">{{item.name}}<span>;</span></span></p>
                <p>抄送人：<span v-for="(item, index) in form.ccList"
                             :key="item.id">{{item.name}}<span>;</span></span></p>
                <p v-if="fileList.length">附件：<span v-for="item in fileList" :key="item.fileId">{{item.fileName || item.name}};</span></p>
            </div>
            <div style="border-top: 1px solid #ddd;padding-top: 10px;">
                <div v-html="form.content"></div>
            </div>
        </div>
        <div slot="footer" class="dialog-footer" style="text-align: center">
            <el-button @click="dialogFormVisible = false" v-if="!isPreview">取 消</el-button>
            <el-button type="success" class="left" @click="toEditView" v-if="isPreview">返 回</el-button>
            <el-button type="primary" @click="sendEmail" v-if="!isPreview">发 送</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import UserSearch from 'components/userSelect/searchDownList'
    import UserGroup from 'components/userSelect/userSelect'
    import FileUpload from 'components/fileUpload'
    import { dateFormat } from 'modules/tools'
    import axios from 'axios'
    import _ from 'underscore'
    import Vueditor from 'components/vueditor'
    // userAttributes 1-应聘者  2-面试官
    export default {
        components: {
            Vueditor, UserSearch, FileUpload, UserGroup
        },
        data () {
            return {
                dialogFormVisible: false,
                renderKey: 1,
                params: null,
                isPreview: false,
                dataList: [
                    {provider: '南油外服', number: 5, users: [{name: '张三', email: 'test1@163.com'}, {name: '李四', email: 'test2@163.com'}, {name: '王五', email: 'test3@163.com'}]},
                    {provider: '软通', number: 2, users: [{name: '张三', email: 'test1@163.com'}, {name: '李四', email: 'test2@163.com'}, {name: '王五', email: 'test3@163.com'}]},
                    {provider: '中科', number: 3, users: [{name: '张三', email: 'test1@163.com'}, {name: '李四', email: 'test2@163.com'}]}
                ],
                form: {
                    name: '',
                    sendEmail: '',
                    recipients: [],
                    ccList: [],
                    delivery: false,
                    mailAttachInfos: [],
                    hrAttachIds: [],
                    content: '',
                    contentCode: ''
                },
                fileList: [],
                placeHolders: [],
                baseData: null,
                formLabelWidth: '120px',
                uploadData: {
                    code: '',
                    fileType: 'upload'
                },
                emailTemplate: '',
                emailTemplateList: [],
                recipients: '',
                recipientsDisabled: false,
                rpIds: []
            }
        },
        methods: {
            // handleFileSuccess (res, file) {
            //     if (res.status) {
            //         this.fileList.push(res.result)
            //     } else {
            //         this.$message.error(res.desc || '上传失败')
            //     }
            // },
            // handleFileRemove (file, fileList) {
            //     this.fileList = fileList
            // },
            // handlePreview (file) {
            //     if (file.preUrl) {
            //         window.open(file.preUrl)
            //     } else {
            //         this.$message.warning('该文件不支持预览')
            //     }
            // },
            togglerUserActive (item) {
                this.$nextTick(() => {
                    item.disabled = !item.disabled
                    if(this.dataList.every(cv => {
                        return (cv.contactList && cv.contactList.length && cv.contactList.every(item => item.disabled)) || (cv.contactList && !cv.contactList.length)
                    })) {
                        this.recipientsDisabled = false
                    } else {
                        this.recipientsDisabled = true
                    }
                })
                
                // this.$set(item, 'disabled', !item.disabled)
            },
            updateData (data) {
                this.form.contentCode = data
            },
            toEditView () {
                this.isPreview = false
            },
            async getEmailTemplate () {
                let res = await this.$axios.get('/system/mailTemplate/listByPhase.api?phase=3')
                this.emailTemplateList = res.status ? res.result.list : []
            },
            show (params) {
                this.getEmailTemplate()
                const rpIds = params.map(item => item.id).join(',')
                this.rpIds = params.map(item => item.id)
                this.$axios.post('/payment/supplierNotifyPanelInfo.api?rpIds=' + rpIds).then(res => {
                    this.dataList = res.result.supplierInfo
                    if(this.dataList) {
                        this.dataList.forEach(cv => {
                            if(cv.contactList && cv.contactList.length) {
                                cv.contactList.map(item => {
                                    this.$set(item, 'disabled', true)
                                })
                            }
                        })
                    }
                    this.recipientsDisabled = false
                    this.placeHolders = res.result.placeHolders
                    this.fileList = []
                    this.params = params
                    this.isPreview = false
                    this.emailTemplate = ''
                    this.form.name = ''
                    // 清空抄送人信息
                    this.$refs.ccList && this.$refs.ccList.$refs.select && this.$refs.ccList.$refs.select.reset()
                    this.form.delivery = false
                    this.form.content = ''
                    this.form.contentCode = ''
                    this.renderKey++
                    this.$refs.editor && (this.$refs.editor.lastRange = null)
                    this.dialogFormVisible = true
                })
            },
            checkForm () {
                if (this.form.name === '') {
                    this.$message({
                        message: '邮件标题不能为空',
                        type: 'warning'
                    })
                    return false
                }
                if (this.form.contentCode === '') {
                    this.$message({
                        message: '邮件内容不能为空',
                        type: 'warning'
                    })
                    return false
                }
                return true
            },
            previewEmailByRecipients() {
                if (this.checkForm() === false) {
                    return false
                }
                if(this.recipientsDisabled) {
                    this.$message({
                        message: '仅支持供应商对接人为空时预览',
                        type: 'warning'
                    })
                    return false
                }
                if(this.$refs.recipients.getSelected().length <= 0) {
                    this.$message({
                        message: '收件人不能为空',
                        type: 'warning'
                    })
                    return false
                }
                this.form.ccList = this.$refs.ccList.getSelected()
                this.interviewerUsers = this.$refs.recipients.getSelected()
                let params = {
                    name: this.form.name,
                    receivers: [{
                        // supplierCode: data.supplierCode,
                        rpIds: this.rpIds,
                        // emails: this.interviewerUsers.map(item => item.email)
                    }],
                    content: this.form.contentCode + this.getSign(),
                    ccs: this.form.ccList.map(item => {
                        let id
                        if(item.id < 0) {
                            id = item.id
                        }else{
                            id = /^\d+$/.test(item.id) ? item.id : null
                        }
                        return {
                            id: id,
                            name: item.name
                        }
                    })
                }
                let url = '/payment/supplierNotifyPreview.api'
                axios.post(url, params, {
                    'X-JSON': true
                }).then(res => {
                    this.form.content = res.result.content
                    this.isPreview = true
                }).catch(function () {
                })
            },
            previewEmail (data) {
                if (this.checkForm() === false) {
                    return false
                }
                this.form.ccList = this.$refs.ccList.getSelected()
                // 给表单设值
                this.interviewerUsers = data.contactList.filter(item => item.disabled !== true) || []
                if(this.$refs.recipients.getSelected().length > 0) {
                    this.interviewerUsers = this.interviewerUsers.concat(this.$refs.recipients.getSelected())
                }
                if (this.interviewerUsers.length === 0) {
                    this.$message({
                        message: '供应商对接人不能为空',
                        type: 'warning'
                    })
                    return false
                }
                let params = {
                    name: this.form.name,
                    receivers: [{
                        supplierCode: data.supplierCode,
                        rpIds: data.rpIdList,
                        emails: this.interviewerUsers.map(item => item.email)
                    }],
                    content: this.form.contentCode + this.getSign(),
                    ccs: this.form.ccList.map(item => {
                        let id
                        if(item.id < 0) {
                            id = item.id
                        }else{
                            id = /^\d+$/.test(item.id) ? item.id : null
                        }
                        return {
                            id: id,
                            name: item.name
                        }
                    })
                }
                let url = '/payment/supplierNotifyPreview.api'
                axios.post(url, params, {
                    'X-JSON': true
                }).then(res => {
                    this.form.content = res.result.content
                    this.isPreview = true
                }).catch(function () {
                })
            },
            sendEmail () {
                if (this.checkForm() === false) {
                    return false
                }
                let url = '/payment/supplierNotify.api'
                // 预览页面this.$refs.ccList为null
                if (this.$refs.ccList) {
                    this.form.ccList = this.$refs.ccList.getSelected()
                }
                var emailLength = 0
                let params = {
                    receivers: this.dataList.map(data => {
                        const emails = data.contactList.filter(item => item.disabled !== true).map(item => item.email)
                        if(emails.length) {
                            emailLength += 1
                        }
                        return {
                            supplierCode: data.supplierCode,
                            rpIds: data.rpIdList,
                            emails: emails
                        }
                    }),
                    recipients: this.$refs.recipients.getSelected().map(item => {
                        let id
                        if(item.id < 0) {
                            id = item.id
                        }else{
                            id = /^\d+$/.test(item.id) ? item.id : null
                        }
                        return {
                            id: id,
                            name: item.name
                        }
                    }),
                    title: this.form.name,
                    attaches: this.fileList,
                    content: '<div style="font-family:微软雅黑;">' + this.form.contentCode + this.getSign() + '</div>',
                    ccs: this.form.ccList.map(item => {
                        let id
                        if(item.id < 0) {
                            id = item.id
                        }else{
                            id = /^\d+$/.test(item.id) ? item.id : null
                        }
                        return {
                            id: id,
                            name: item.name
                        }
                    })
                }
                if (this.$refs.recipients.getSelected().length <= 0 && !emailLength) {
                    this.$message({
                        message: '供应商对接人和收件人不能同时为空',
                        type: 'warning'
                    })
                    return false
                }
                // 给表单设置
                axios.post(url, params, {
                    'X-showMessage': true,
                    'X-JSON': true
                }).then(res => {
                    this.dialogFormVisible = false
                    this.$emit('sendSuccess', this.params)
                })
            },
            getFileData () {
                let data = []
                this.form.hrAttachIds.forEach(id => {
                    let item = _.findWhere(this.baseData.hrAttachList, {id: id})
                    item && data.push(['hr', item.md5, item.fileId, item.attachName].join(','))
                })
                return []
            },
            getSign () {
                let userInfo = this.$store.state.user
                return `<div style="color: #999;margin-top: 50px;font-family: 微软雅黑;font-size: 14px;">
                            <p style="margin: 5px 0;border-bottom: 1px solid #999;width: 300px;">${dateFormat(new Date())}</p>
                            <p style="margin:5px 0;">发件人：${userInfo.name || '-'}</p>
                            <p style="margin:5px 0;">部门：${userInfo.deptName || '-'}</p>
                            <p style="margin:5px 0;">POPO：${userInfo.email || '-'}</p>
                        </div>`
            },
            renderEmailTemplate (id) {
                let list = this.emailTemplateList.find(el => el.id === id) || []
                this.form.name = list.title || ''
                this.$refs.editor.resetContent(list.content || '')
            }
        },
        computed: {
            getAttachItems () {
                let ids = this.form.hrAttachIds,
                    res = []
                this.baseData.hrAttachList.forEach(item => {
                    if (ids.indexOf(item.id) > -1) {
                        res.push(item)
                    }
                })
                return res
            },
            senderTitle () {
                return this.isPreview ? '邮件预览' : '邮件发送'
            },
            showPreviewBtn () {
                return !this.isPreview
            }
        }
    }
</script>
<style lang="scss">
    .scoped-interivew-email {
        .previewView {
            overflow : auto;
            height   : 520px;
        }
        .quickTool {
            .el-tag {
                cursor : pointer;
                margin-right : 5px;
            }
        }
        .dialog-footer {
            button {
                width : 150px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// salaryEmailDialog.vue?f25a6ddc